import React from "react";
import "./style/index.css";
// import { icons } from '../../../assets/icons';
import Skeleton from "react-loading-skeleton";
// import { icons } from "../../assets/icons";

interface PaginationProps {
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
  className?: string;
  onPageChange: (page: number) => void;
  loading?: boolean;
  iconColor?: string;
  canHide?: boolean;
}

const Pagination = ({
  currentPage,
  itemsPerPage,
  totalItems,
  onPageChange,
  className,
  loading,
  canHide,
  iconColor,
}: PaginationProps) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages && !loading) {
      onPageChange(page);
    }
  };

  const icons = {
    chevron_left: (param?: any) => {
      return (
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.5 11L1.5 6L6.5 1"
            stroke={param || "var(--primary-base-color)"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    },
    chevron_right: (param?: any) => {
      return (
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 11L6.5 6L1.5 1"
            stroke={param || "var(--primary-base-color)"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    },
  };

  const iconColorVal = iconColor || "var(--primary-base-color)";

  if (totalItems <= itemsPerPage && canHide){
	return <React.Fragment></React.Fragment>
  }
    return (
      <div
        className={`pagination-reusable-raven-box-wrap border-theme ${className}`}
      >
        <div className="pagination__controls">
          {typeof currentPage !== "number" && itemsPerPage ? (
            <></>
          ) : (
            <div className="pagination__page-count">
              {isNaN(totalItems) ? (
                <Skeleton width={80} height={20} />
              ) : (
                `${((currentPage ?? 0) - 1) * itemsPerPage + 1} - ${Math.min(
                  currentPage * itemsPerPage,
                  totalItems ?? 0
                )} of ${totalItems ?? 0}`
              )}
            </div>
          )}
          {loading ? (
            <Skeleton style={{ margin: "0rem 1rem" }} width={17} height={17} />
          ) : (
            <div
              className={`pagination__button${
                currentPage === 1 ? " pagination__button--disabled" : ""
              }`}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              {icons.chevron_left(iconColorVal)}
            </div>
          )}
          {loading ? (
            <Skeleton width={17} height={17} />
          ) : (
            <div
              className={`pagination__button${
                currentPage === totalPages
                  ? " pagination__button--disabled"
                  : ""
              }`}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              {icons.chevron_right(iconColorVal)}
            </div>
          )}
        </div>
      </div>
    );
};

export default Pagination;
